import { FC } from 'react';
import Button from './button';
import { ButtonTheme } from './button-theme';

const ExportButton: FC<{
  isLoading?: boolean;
  onExport: () => void;
}> = ({
  isLoading,
  onExport
}: {
  isLoading?: boolean;
  onExport: () => void;
}) => {
  return (
    <>
      <Button
        theme={ButtonTheme.CANCEL}
        identifier="export"
        onClick={onExport}
        isLoading={isLoading}
      >
        <div className="flex items-center justify-between">
          <i className="ra-icons-generic-download text-sm mr-2 flex"></i>
          <span>Export</span>
        </div>
      </Button>
    </>
  );
};

export default ExportButton;
